export default __webpack_public_path__ + "static/media/taskade.9ce2312b.png";